import { React, ts } from '_core';

import Chart from './chart';
import { Params } from './types';

type PortfolioTabularOutputProps = {
  id: string;
  params: Params;
  setParams: (_v: Params) => void;

  queryParams?: { initial?: string };
  goFullScreen?: (_v: string) => void;
  fullScreen?: boolean;
  widgetPaths?: Record<'portfolio_report' | 'portfolio_holdings_alpha_exposures', string>;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
};

const PortfolioTabularOutput = ({
  id,
  loadWidgetData,
  widgetPaths,
  fullScreen,
  goFullScreen,
  queryParams,
  params,
  setParams,
}: PortfolioTabularOutputProps) => {
  return (
    <Chart
      id={id}
      setParams={setParams}
      params={params}
      loadWidgetData={loadWidgetData}
      portfolios={widgetPaths['portfolio_report']}
      alphaExposures={widgetPaths['portfolio_holdings_alpha_exposures']}
      fullScreen={fullScreen}
      queryParams={queryParams}
      goFullScreen={goFullScreen}
    />
  );
};

export default PortfolioTabularOutput;
